import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vc-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
  standalone: false,

})
export class CreateUserComponent implements OnInit {
  form!: FormGroup;

  statusList = ['Active', 'De-Activated'];
  typeList = ['Operations User', 'Hospital User', 'Admin User'];
  roleList = ['Level 1', 'Level 2', 'Level 3', 'Admin'];
  assignmentSourceList = ['Default', 'Custom', 'None'];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      userName: ['', Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      userStatus: ['Active', Validators.required],
      userType: ['', Validators.required],
      userRole: ['', Validators.required],
      lastLoggedIn: [null],
      assignmentSource: ['Default', Validators.required]
    });

    // If editing existing user, patch values
    if (this.data && this.data.user) {
      this.form.patchValue(this.data.user);
    }
  }

  close(): void {
    this.dialogRef.close('closed');
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = {
      userName: this.form.value.userName,
      userEmail: this.form.value.userEmail,
      userStatus: this.form.value.userStatus,
      userType: this.form.value.userType,
      userRole: this.form.value.userRole,
      lastLoggedIn: this.form.value.lastLoggedIn,
      assignmentSource: this.form.value.assignmentSource
    };

    this.dialogRef.close({ action: 'create', data: payload });
  }
}
